import React from 'react';

const Column = ({ children, title, displayTitle, format }) => {
  const shouldRenderTitle = title !== undefined && displayTitle;

  return (
    <div className={`column-component ${shouldRenderTitle ? 'has-title' : 'no-title'}`}>
      {shouldRenderTitle && <div className="column-title">{title}</div>}
      <div className="column-content">
        {React.Children.map(children, (child) => React.cloneElement(child, { format }))}
      </div>
    </div>
  );
};

export default Column;
